import { SfSelectOption } from 'ngx-smart-form';

export interface CmsCounties {
  data: {
    provinces: {
      data: {
        attributes: {
          code: string;
          name: string;
          sign: string;
        };
      }[];
    };
  };
}

export class Counties {
  static getOptions(data?: CmsCounties): SfSelectOption[] {
    const options: SfSelectOption[] =
      data?.data.provinces.data.map((el) => ({
        value: el.attributes.sign,
        view: el.attributes.name,
      })) || [];
    return options;
  }
}
